import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import Layout from "./templates/layout";
import Home from "./pages/Home";
import Article from "./pages/Article";
import Articles from "./pages/Articles";
import Recipes from "./pages/Recipes";
import ArticlePillar from "./pages/ArticlePillar/ArticlePillar";
import AuthorizeRoute from "./auth/AuthorizeRoute";
import { OtpRoute } from "./auth/OtpRoute";

import { AccountActivation, ExpiredKey, InvalidKey } from "./pages/AccountActivation";
import MyProgress, { FollowupWeight } from "./pages/MyProgress";
import PageNotFound from "./pages/PageNotFound";
import { Redirect, useHistory } from "react-router-dom";
import PolicyDocument from "./pages/PolicyDocument";
import MyPath from "./pages/MyPath";
import MyPathPreview from "./pages/MyPathPreview";
import VideoPage from "./pages/VideoPage";
import Step from "./pages/Step";
import StepPreview from "./pages/StepPreview";
import StepCompleted from "./pages/StepCompleted";
import SelectProgramme from "./pages/SelectProgramme";
import { EligibilityCheckerRoot } from "./pages/EligibilityChecker";
import { OneTimePasscodeRequest, OneTimePasscodeVerify } from "./pages/OneTimePasscodeRoot";
import { EligibilityCheckerRoot as EligibilityCheckerRootLoseWeight } from "./pages/EligibilityCheckerLoseWeight";
import { EligibilityCheckerRoot as EligibilityCheckerRootSmokeFree } from "./pages/EligibilityCheckerSmokeFree";

import { ProfileBuilderRoot, ProfileBuilderSelfRoot } from "./pages/ProfileBuilder";
import { ValidateEmailVerification, EmailVerification } from "./pages/EmailVerification";
import BookAppointmentFlow from "./pages/BookAppointmentFlow";
import Recipe from "./pages/Recipe";
import FeatureFlagRoute from "../components/routes/FeatureFlagRoute";
import Features from "../enums/features";
import { programmes } from "../enums/programmes";

export default function App() {
  const history = useHistory();

  // When the modal is active and the user navigates back then remove modal-active class
  useEffect(() => {
    return history.listen(() => {
      document.getElementById("root").classList.remove("modal-active");
    });
  }, [history]);

  return (
    <Layout>
      <Switch>
        <Redirect from="/index.html" to="/" />
        <AuthorizeRoute exact path="/" component={Home} />
        <Route path="/account/verify-email/:key" component={ValidateEmailVerification} />
        <AuthorizeRoute exact path="/account/verify-email" component={EmailVerification} />
        <AuthorizeRoute path="/book-appointment/:programmeSlug" component={BookAppointmentFlow} />
        <AuthorizeRoute exact path="/explore/articles/nutrition" component={ArticlePillar} />
        <AuthorizeRoute exact path="/explore/articles/movement" component={ArticlePillar} />
        <AuthorizeRoute exact path="/explore/articles/alcohol" component={ArticlePillar} />
        <AuthorizeRoute exact path="/explore/articles/mind" component={ArticlePillar} />
        <AuthorizeRoute exact path="/explore/articles/sleep" component={ArticlePillar} />
        <AuthorizeRoute exact path="/explore/articles/smoking" component={ArticlePillar} />
        <AuthorizeRoute path="/explore/articles/:slug" component={Article} />
        <AuthorizeRoute exact path="/explore/articles" component={Articles} />
        <AuthorizeRoute path="/explore/recipes/:slug" component={Recipe} />
        <AuthorizeRoute exact path="/explore/recipes" component={Recipes} />
        <AuthorizeRoute
          exact
          path="/my-path/:programmeSlug/:stepTitleSlug/part-:partNumberString/:partTitleSlug/:sectionSlug"
          component={VideoPage}
        />
        <AuthorizeRoute
          exact
          path="/my-path/:programmeSlug/step-:stepNumber/completed"
          component={StepCompleted}
        />
        <AuthorizeRoute exact path="/my-path/:programmeSlug" component={MyPath} />

        <FeatureFlagRoute
          exact
          path="/my-path/:programmeSlug/preview"
          component={MyPathPreview}
          featureKey={Features.MULTIPLE_MY_PATH}
          requireAuth={true}
        />
        <FeatureFlagRoute
          exact
          path="/my-path/:programmeSlug/step-:stepNumber/preview"
          component={StepPreview}
          featureKey={Features.MULTIPLE_MY_PATH}
          requireAuth={true}
        />
        <AuthorizeRoute exact path="/my-path/:programmeSlug/step-:stepNumber" component={Step} />
        <AuthorizeRoute
          path="/my-progress/:programmeSlug/followup-weight/journey/:journeyId"
          component={FollowupWeight}
          excludeFromRouting={true}
        />
        <AuthorizeRoute path="/my-progress/:programmeSlug" component={MyProgress} />

        <AuthorizeRoute path="/profile-builder/:programmeSlug" component={ProfileBuilderRoot} />
        <AuthorizeRoute path="/sign-up/profile-builder/:programmeSlug" component={ProfileBuilderSelfRoot} />
        <Route path="/sign-up/activation/:key" component={AccountActivation} />
        <Route exact path="/sign-up/activation/key-invalid" component={InvalidKey} />
        <Route exact path="/sign-up/activation/key-expired" component={ExpiredKey} />

        <OtpRoute
          exact
          path="/sign-up/eligibility-checker/lose-weight"
          component={EligibilityCheckerRootLoseWeight}
          programmeId={programmes["lose-weight"].id}
        />
        <OtpRoute
          exact
          path="/sign-up/eligibility-checker/smoke-free"
          component={EligibilityCheckerRootSmokeFree}
          programmeId={programmes["smoke-free"].id}
        />
        <OtpRoute exact path="/select-programme" component={SelectProgramme} />
        <Route exact path="/sign-up/eligibility-checker" component={EligibilityCheckerRoot} />
        <FeatureFlagRoute
          exact
          path="/sign-up"
          component={OneTimePasscodeRequest}
          featureKey={Features.MULTIPLE_JOURNEYS}
          requireAuth={false}
        />
        <FeatureFlagRoute
          exact
          path="/sign-up/otp/verify/:email"
          component={OneTimePasscodeVerify}
          featureKey={Features.MULTIPLE_JOURNEYS}
          requireAuth={false}
        />
        <Route exact path="/about" component={PolicyDocument} />
        <Route exact path="/contact" component={PolicyDocument} />
        <Route exact path="/accessibility" component={PolicyDocument} />
        <Route exact path="/terms-and-conditions" component={PolicyDocument} />
        <Route exact path="/privacy" component={PolicyDocument} />
        <Route exact path="/error/404" component={PageNotFound} />
        <Route path="/authentication" />
        <Route path="*">
          <Redirect push to="/error/404" />
          <PageNotFound />
        </Route>
      </Switch>
    </Layout>
  );
}
